import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ScheduleFilledSvg from "@ant-design/icons-svg/es/asn/ScheduleFilled";
import AntdIcon from "../components/AntdIcon";
var ScheduleFilled = function ScheduleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ScheduleFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ScheduleFilled.displayName = 'ScheduleFilled';
}
export default /*#__PURE__*/React.forwardRef(ScheduleFilled);